import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    linkId = '',
    inputName = '',
    password = '',
    accessToken = '',
    ...formData
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.das.utableShare.saveFormData, {
        linkId,
        password,
        inputName,
        accessToken,
        ...formData,
    }, options);
    if (error) return { error, status };
    return content || {};
};
